import React from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from '../../../global/modal/Modal'
import { CryptoProceedModal } from './CryptoProceedModal'

import styles from './CardPaymentProviderProceedModal.module.scss'

interface CryptoPaymentProviderModalProps {
  onProceed(): void
  onClose(): void
}

export const CryptoPaymentProviderProceedModal: React.FC<CryptoPaymentProviderModalProps> = ({
  onProceed,
  onClose,
}) => {
  const handleProceed = () => {
    onProceed()
  }

  const { t } = useTranslation()

  return (
    <Modal
      closeModal={onClose}
      cardClassName={styles.modal}
      pullDown
      render={() => <CryptoProceedModal title={t('Deposit of')} onProceed={handleProceed} />}
    />
  )
}
